<template>
  <div ref="slider">
    <slot name="control-prev" />
    <div class="sliderContainer">
      <div class="slider__list" data-slider-list>
        <div
          v-for="(item, index) in sliderItems"
          v-bind:key="index"
          class="slider__item"
          data-slider-slide
        >
          <picture
            class="picture has-aspect-ratio is-1by1-desktop is-1by1-mobile"
          >
            <template v-for="(data, i) in item">
              <source
                :media="data.media"
                :sizes="data.Sizes"
                :data-srcset="data.srcset"
                :key="i"
                v-if="data.src == null"
              />
              <img
                v-bind:key="i"
                v-if="data.src != null && enablelazyLoad"
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                :data-src="data.src"
                :alt="data.altText"
                class="lazy"
              />
              <img
                v-bind:key="i"
                v-if="data.src != null && !enablelazyLoad"
                :src="data.src"
                :alt="data.altText"
              />
            </template>
          </picture>
        </div>
      </div>
      <slot name="vto"></slot>
    </div>
    <slot name="control-next" />
    <div class="thumbanial-container">
      <div
        class="slider --controls-centered --cards card-list"
        ref="thumbnailslider"
      >
        <button
          type="button"
          class="slider-control slider-control__prev product-slider-click-previous thumbnailprev"
          :class="[isSliderEnable ? '' : 'hideBtn']"
          data-slider-control="prev"
          data-analytics='{"domEvent":"click","locatorType":"className","locatorQuery":"product-slider-click-previous","timeduration":"","scrollratio":"","triggerOnExternalApiResponse":false,"eventName":"","eventProperties":{"event":"uaevent","ecommerce":"undefined","event_name":"product_image_change","click_action":"previous","product_info":"deep molecular repairing hair rinse-off serum for damaged hair.::3474637153502"},"parentSelector":"","childSelector":"","taggingData":null}'
        >
          <svg role="img" :aria-label="ariaLabelPrevious">
            <use
              xlink:href="#arrow-left"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            ></use>
          </svg>
        </button>
        <ul
          class="slider-control__dots lp-thumbnail slider__list"
          :aria-label="ariaLabelPagination"
          data-slider-list
          :class="[isSliderEnable ? 'isSliderEnable' : '']"
        >
          <li
            class="slider-control__dot slider__item"
            v-for="(item, index) in thumbnailItems"
            v-bind:key="index"
            data-slider-slide
          >
            <div class="card">
              <button
                :aria-label="item.altText"
                aria-current="true"
                data-slider-control
                :data-slide-index="index"
              >
                <img
                  v-if="enablelazyLoad"
                  :alt="item.altText"
                  src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                  :data-src="item.src"
                  class="lazy"
                />
                <img
                  v-if="!enablelazyLoad"
                  :alt="item.altText"
                  :src="item.src"
                />
              </button>
            </div>
          </li>
        </ul>
        <button
          type="button"
          class="slider-control slider-control__next product-slider-click-next thumbnailnext"
          :class="[isSliderEnable ? '' : 'hideBtn']"
          data-slider-control="next"
          data-analytics='{"domEvent":"click","locatorType":"className","locatorQuery":"product-slider-click-next","timeduration":"","scrollratio":"","triggerOnExternalApiResponse":false,"eventName":"","eventProperties":{"event":"uaevent","ecommerce":"undefined","event_name":"product_image_change","click_action":"next","product_info":"deep molecular repairing hair rinse-off serum for damaged hair.::3474637153502"},"parentSelector":"","childSelector":"","taggingData":null}'
        >
          <svg role="img" :aria-label="ariaLabelNext">
            <use
              xlink:href="#arrow-right"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            ></use>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getSlider } from 'Utils/BaseSlider';

let sliderInstance = null;
let thumbnailsliderInstance = null;

export default {
  name: 'media-gallery',

  props: {
    variants: [],
    thumbnails: [],
    ariaLabelNext: {
      type: String,
      required: true,
      default: 'Next',
    },
    ariaLabelPrevious: {
      type: String,
      required: true,
      default: 'Previous',
    },
    ariaLabelPagination: {
      type: String,
      required: true,
      default: 'Pagination',
    },
  },
  data() {
    return {
      sliderItems: [],
      thumbnailItems: [],
      enablelazyLoad: true,
      isSliderEnable: false,
      isDesktop: window.innerWidth >= 1024,
      isInitialLoad: true
    };
  },
  created() {
    let singleVariant = this.variants && this.variants[0];
    let singleVariantthumbnail = this.thumbnails && this.thumbnails[0];
    singleVariant?.images.forEach((data) => {
      this.sliderItems.push(data);
    });
    singleVariantthumbnail?.images.forEach((data) => {
      this.thumbnailItems.push(data);
    });
    this.checkSlider();
  },
  mounted() {
    let vtocontainer = document.getElementsByClassName('vto-container');
    if (vtocontainer.length > 0) {
      let btnWidth = vtocontainer[0].offsetWidth;
      vtocontainer[0].style.left = 'calc(50% - ' + btnWidth / 2 + 'px)';
    }
    eventBus.$on('shade::selected', this.updateMediaItems);
    eventBus.$on('package::selected', (productEan) => {
      if (this.isInitialLoad) {
        this.isInitialLoad = false;
        this.enablelazyLoad = true;
      } else {
        this.enablelazyLoad = false;
        this.updateMediaItems(productEan);
      }
    });
    this.initSlider();
    this.enablelazyLoad = true;
  },
  destroyed() {
    sliderInstance.clear();
  },
  methods: {
    checkSlider() {
      let sliderCount = this.isDesktop ? 5 : 4;
      if (this.thumbnailItems.length > sliderCount) {
        this.isSliderEnable = true;
      } else {
        this.isSliderEnable = false;
      }
    },
    initSlider() {
      sliderInstance = getSlider(this.$refs.slider, 'thumbnail');
      thumbnailsliderInstance = getSlider(
        this.$refs.thumbnailslider,
        'default'
      );
      sliderInstance.init();
      thumbnailsliderInstance.init();
    },
    updateMediaItems(productEan) {
      this.sliderItems = [];
      this.thumbnailItems = [];
      this.variants.forEach((data) => {
        if (data.EAN == productEan) {
          data.images.forEach((img) => {
            this.sliderItems.push(img);
          });
        }
      });
      this.thumbnails.forEach((data) => {
        if (data.EAN == productEan) {
          data.images.forEach((img) => {
            this.thumbnailItems.push(img);
          });
        }
      });
      this.checkSlider();
      sliderInstance.clear();
      thumbnailsliderInstance.clear();
      sliderInstance.slides = [];
      thumbnailsliderInstance.slides = [];
      this.$nextTick(() => {
        this.initSlider();
      });
    },
  },
};
</script>
